export const FRONT_OFFICE_SHORTCUT_SECTIONS = [
  {
    title: 'Help And Navigation',
    description: 'Quick ways to open the most-used front-office panels.',
    items: [
      { id: 'shortcut-help', combo: 'F2', title: 'Open shortcuts help', description: 'Show the keyboard shortcuts guide.' },
      { id: 'shortcut-close', combo: 'Esc', title: 'Close active popup', description: 'Dismiss the top-most dialog, drawer, or help screen.' },
      { id: 'shortcut-dashboard', combo: 'Ctrl+Alt+A', title: 'Agent dashboard', description: 'Open the dashboard overlay.' },
      { id: 'shortcut-chat', combo: 'Ctrl+Alt+K', title: 'Agent chat', description: 'Open the agent chat selector.' }
    ]
  },
  {
    title: 'Call Controls',
    description: 'Fast call actions for live handling.',
    items: [
      { id: 'shortcut-new-call', combo: 'Ctrl+Alt+N', title: 'New call mode', description: 'Trigger the top bar new-call action.' },
      { id: 'shortcut-dialpad', combo: 'Ctrl+Alt+D', title: 'Dialpad', description: 'Open the dialpad window.' },
      { id: 'shortcut-dialpad-enter', combo: 'Enter / NumpadEnter', title: 'Dial active number', description: 'Inside the dialpad, press Enter to place the call.' },
      { id: 'shortcut-hold', combo: 'Ctrl+Alt+H', title: 'Hold or resume', description: 'Toggle hold on the active call.' },
      { id: 'shortcut-mute', combo: 'Ctrl+Alt+M', title: 'Mute or unmute', description: 'Toggle the local mute state.' },
      { id: 'shortcut-transfer', combo: 'Ctrl+Alt+T', title: 'Transfer call', description: 'Open the transfer agent list.' },
      { id: 'shortcut-feedback', combo: 'Ctrl+Alt+F', title: 'Transfer to feedback', description: 'Route the active call to feedback rating.' },
      { id: 'shortcut-hangup', combo: 'Ctrl+Alt+X', title: 'Hang up call', description: 'End the active call immediately.' },
      { id: 'shortcut-emergency', combo: 'Ctrl+Alt+Shift+X', title: 'Emergency cleanup', description: 'Hang up all active channels when needed.' }
    ]
  },
  {
    title: 'Caller Workspace',
    description: 'Open the side panels and supporting tools without leaving the keyboard.',
    items: [
      { id: 'shortcut-search', combo: 'Ctrl+Alt+S', title: 'Search', description: 'Open caller search and history lookup.' },
      { id: 'shortcut-list', combo: 'Ctrl+Alt+L', title: 'Caller list', description: 'Open the caller list modal.' },
      { id: 'shortcut-profile', combo: 'Ctrl+Alt+P', title: 'Caller profile', description: 'Open the profile view.' },
      { id: 'shortcut-reminders', combo: 'Ctrl+Alt+R', title: 'Reminders', description: 'Open reminders.' },
      { id: 'shortcut-history', combo: 'Ctrl+Alt+Y', title: 'Caller history', description: 'Open the caller history modal.' },
      { id: 'shortcut-notes', combo: 'Ctrl+Alt+O', title: 'Notes or comments', description: 'Open notes and comments.' },
      { id: 'shortcut-sms', combo: 'Ctrl+Alt+U', title: 'Send Whatsapp', description: 'Open the SMS panel.' },
      { id: 'shortcut-registration', combo: 'Ctrl+Alt+I', title: 'Extension help', description: 'Open SIP registration or extension help.' }
    ]
  },
  {
    title: 'Form Actions',
    description: 'Shortcuts for the main complaint and caller workflow.',
    items: [
      { id: 'shortcut-new-caller', combo: 'Ctrl+Alt+Shift+N', title: 'New caller form', description: 'Reset the caller form for a fresh caller.' },
      { id: 'shortcut-new-query', combo: 'Ctrl+Alt+Shift+Q', title: 'New query', description: 'Reset the complaint details area for a fresh query.' },
      { id: 'shortcut-clear-info', combo: 'Ctrl+Alt+Shift+C', title: 'Clear all info', description: 'Clear the loaded caller information.' },
      { id: 'shortcut-proceed', combo: 'Ctrl+Alt+Shift+Enter', title: 'Proceed', description: 'Run the main proceed action from the center panel.' }
    ]
  }
];

export default FRONT_OFFICE_SHORTCUT_SECTIONS;
